import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getWrittenExecutiveSummary, updateWrittenExecutiveSummary } from './index';

export const createNominationWrittenExecutiveSummaryApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getWrittenExecutiveSummary: (instance: IPublicClientApplication, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getWrittenExecutiveSummary(fetchContext, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getWrittenExecutiveSummary', isInFlight);
    },
  ),
  updateWrittenExecutiveSummary: (instance: IPublicClientApplication, nominationId: number, content: string) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateWrittenExecutiveSummary(fetchContext, nominationId, content, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateWrittenExecutiveSummary', isInFlight);
    },
  ),
});
